import { useEffect, useState } from "react"
import useHttp from "../../../../hooks/use-http"

const ChooseProduct = ({chosenProduct, setProduct}) => {
    const [productList, setProductList] = useState([])


    const {isLoading : formLoading, error : formError, sendRequest : sendForm} = useHttp( (data) =>{
        setProductList(data['results'])
        setProduct(data['results'][0].id)
    })

    useEffect( () => {
        sendForm({url:'/rest/product/list_store/', json:true})
    }, [])
    const productLabel = (product) => {
        const name = product.name || product.product_object?.name || ''
        const people = product.max_people || product.product_object?.max_people
        return people ? `${name} (${people} personen)` : name
    }
    return (
        (productList.length == 1) ?
            <h6>{productLabel(productList[0])}</h6>
            :
            <select onChange={ (e) => {setProduct(e.target.value)}} class="form-select mb-2 me-auto" aria-label="Default select example">
                {
                productList.map( (product, index) => 
                    <option key={product.id} defaultValue={product.id} selected={product.id===chosenProduct} > 
                        {productLabel(product)}
                    </option>)
                }
            </select>
    )
    
}

export default ChooseProduct